import { render, staticRenderFns } from "./PainelBling.vue?vue&type=template&id=0d637007&scoped=true"
import script from "./PainelBling.vue?vue&type=script&lang=js"
export * from "./PainelBling.vue?vue&type=script&lang=js"
import style0 from "./PainelBling.vue?vue&type=style&index=0&id=0d637007&prod&lang=css"
import style1 from "./PainelBling.vue?vue&type=style&index=1&id=0d637007&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d637007",
  null
  
)

export default component.exports